import { BuildingGroupSelectFormikField } from '../../BuildingGroup'
import { FieldStackedLabel } from '../../Field'

import { DOC_FLOW_BUILDING_GROUP_FIELD_NAME } from './DocFlowBuildingGroup.constants'

function DocFlowBuildingGroupField({
  inputInfo,
  inputLabel,
  name = DOC_FLOW_BUILDING_GROUP_FIELD_NAME,
  placeholder,
  ...restProps
}) {
  return (
    <BuildingGroupSelectFormikField
      {...restProps}
      Field={FieldStackedLabel}
      controlProps={{
        contentProps: {
          inputProps: {
            placeholder,
          },
        },
      }}
      fieldComponentProps={{
        info: inputInfo,
        label: inputLabel,
      }}
      name={name}
    />
  )
}

export default DocFlowBuildingGroupField
